import { useQuery } from '@apollo/client'
import { FunctionComponent } from 'react'
import { Button, Loader } from '../../../components'
import { GET_BLACK_FRIDAY_PACKS_WITH_BRAND } from '../../../gql/creditPacks'
import { Brand, GetCreditPacksResponse, User } from '../../../gql/types'
import { CreditPacks } from '../../CreditPacks'
import { DEAL_CODE } from '../../../utils/constants'

interface IProps {
  user: User
  brand: Brand
}

export const BrandBlackFridayPacks: FunctionComponent<IProps> = ({
  user,
  brand,
}) => {
  const { data, loading, error } = useQuery<
    {
      getBrandById: Brand
      getBlackFridayPacks: GetCreditPacksResponse
    },
    { brandId: Number; currency: String }
  >(GET_BLACK_FRIDAY_PACKS_WITH_BRAND, {
    variables: {
      brandId: brand.id,
      currency: brand.currency,
    },
  })

  if (loading) {
    return <Loader />
  }

  if (error) {
    return <p>There has been an error. Try refreshing the page</p>
  }

  const onSkip = () => {
    localStorage.removeItem(DEAL_CODE)
    window.location.href = '/'
  }

  return (
    <div className='text-center'>
      <CreditPacks
        user={user}
        brand={data.getBrandById}
        creditPacks={data.getBlackFridayPacks}
        isBlackFriday={true}
      />

      <div className='px-8'>
        <Button
          title='Skip deal'
          onClick={onSkip}
          className='mb-8 w-full sm:w-[300px]'
        />
      </div>
    </div>
  )
}
